<template>
  <div id="app">
    <ais-instant-search
      :index-name="config.INDEX"
      :search-client="searchClient"
      :routing="routing"
      :search-function="searchFunction"
      :insights-client="insightsClient"
    >
      <AlgoliaSearch />
      <BackToTop v-if="state.activeView !== 'Map'" />
    </ais-instant-search>
  </div>
</template>

<script>
import 'reset-css';
import AlgoliaSearch from './components/AlgoliaSearch.vue';
import BackToTop from './components/BackToTop.vue';
import { config, client, store } from './store.js';
import { routing } from './routing';

export default {
  data() {
    return {
      config: config,
      state: store.state,
      searchClient: client,
      routing,
      insightsClient: window.aa,
    };
  },
  components: {
    AlgoliaSearch,
    BackToTop,
  },
  methods: {
    searchFunction(helper) {
      const page = helper.state.page;
      if (this.state.type) {
        helper.setState(
          helper.state
            .addFacet('type')
            .removeFacetRefinement('type')
            .addFacetRefinement('type', this.state.type)
            .setPage(page)
        );
      }

      helper.search();
    },
  },
};
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}

body {
  font-family: 'Work Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 13px;
}

.container {
  max-width: $widescreen;
  width: 100%;
  margin: 0 auto;
}
</style>
